import { AttributeExpression, NodeExpression } from './expressions';
import { getNodePath, getNodeByPath, text, markerNumber, TEXT_ELEMENT, getMarkers } from './utils';
function treeWalkerFilter() {
    return NodeFilter.FILTER_ACCEPT;
}
treeWalkerFilter.acceptNode = treeWalkerFilter;
export function linkAttributes(element, linkedExpressions) {
    const attrs = element.attributes;
    let i = attrs.length;
    while (i--) {
        const { name, value } = attrs.item(i);
        const n = markerNumber(value);
        if (n !== -1) {
            element.removeAttribute(name);
            linkedExpressions[n] = {
                type: AttributeExpression,
                name,
                nodePath: getNodePath(element)
            };
        }
    }
}
export function linkComment(node, linkedExpressions) {
    const n = markerNumber(node.data);
    if (n !== -1) {
        linkedExpressions[n] = {
            type: NodeExpression,
            nodePath: getNodePath(node)
        };
        node.nodeValue = '';
    }
}
export function linkTexts(node, linkedExpressions) {
    getMarkers(node.data).forEach((key) => {
        const keyNode = text();
        node = node.splitText(node.data.indexOf(key));
        node.deleteData(0, key.length);
        node.parentNode.insertBefore(keyNode, node);
        linkedExpressions[markerNumber(key)] = {
            type: NodeExpression,
            nodePath: getNodePath(keyNode)
        };
    });
}
export function linkExpressions(root) {
    const treeWalker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT, treeWalkerFilter, false);
    const linkedExpressions = [];
    while (treeWalker.nextNode()) {
        const node = treeWalker.currentNode;
        if (node.nodeType === Node.ELEMENT_NODE) {
            linkAttributes(node, linkedExpressions);
            if (TEXT_ELEMENT.test(node.tagName)) {
                [].forEach.call(node.childNodes, node => linkTexts(node, linkedExpressions));
            }
        }
        else
            linkComment(node, linkedExpressions);
    }
    return linkedExpressions;
}
export function resolve(fragment, symbols) {
    return symbols.map(symbol => new symbol.type(getNodeByPath(fragment, symbol.nodePath), symbol.name));
}
